import { SectionMessage, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { formatAmountCurrency } from '../../../../utils/stringFormatter'
import { BillType } from '../../../bills/enums/billType'

interface PrepaymentDifferenceLineProps {
  difference: number
  currency: string
  subjectType?: string
}

export const PrepaymentDifferenceLine = ({
  difference,
  currency,
  subjectType,
}: PrepaymentDifferenceLineProps): ReactElement => {
  const { t } = useTranslation()
  const formattedDifference = formatAmountCurrency(difference, currency)

  const labelText =
    subjectType === BillType.Bill
      ? t('bill.payment_reconcile.prepayment.difference.title.bill')
      : t('bill.payment_reconcile.prepayment.difference.title.invoice')

  const titleKey =
    subjectType === BillType.Bill
      ? 'bill.payment_reconcile.prepayment.difference.content.bill'
      : 'bill.payment_reconcile.prepayment.difference.content.invoice'
  return (
    <SectionMessage icon="circleCheck" title={labelText} variant="info">
      <Text>
        <Trans i18nKey={titleKey} tOptions={{ difference: formattedDifference }} components={{ 1: <strong /> }} />
      </Text>
    </SectionMessage>
  )
}
